import React, { useEffect, useState } from 'react';
import { Modal, notify, InfoCard } from 'app/components';
import { Sparkle } from '@phosphor-icons/react';
import MeetingDetails from '../../../event-create/components/step-1/meetingDetails';
import { isValidURL } from '../../../../utils/commonUtils';


const MeetingDetailsModal = ({ show, onClose, formData, onChange }) => {
  const [data, setData] = useState(formData);
  const [error, setError] = useState({});

  useEffect(() => {
    setData(formData);
  }, [formData]);

  const handleSave = () => {
    if (!data.meeting_link?.trim()) {
      setError({ meeting_linkError: 'Please enter the meeting link to continue' });
      return;
    }
    if (!isValidURL(data.meeting_link.trim())) {
      setError({ meeting_linkError: 'Please enter a valid meeting link' });
      return;
    }
    onChange(data, 'Updated successfully', onClose);
  };

  return (
    show && (
      <Modal size="medium" 
        className="modal-meeting-details" 
        primaryText="Save" 
        secondaryText="Cancel" 
        onClickPrimaryCta={handleSave} 
        onClickSecondaryCta={onClose}>

        <h1 className="heading-24">Edit meeting details</h1>

        <MeetingDetails 
          formData={data} 
          setFormData={setData}
          error={error}
          setError={setError}
        />

        <InfoCard content="This can be edited until 2 hours before the event starts." 
          icon={<Sparkle weight="fill" 
            size={24} />} 
        />
        
      </Modal>
    )
  );
};

export default MeetingDetailsModal;
